import React, { forwardRef, useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import { useQuery, gql } from '@apollo/client';

// @ts-expect-error
import CmsContent from '../Unit/CmsContent';
import JsonCmsContent from '../../../content/JsonCmsContent';
import { User } from '../../../../context/AuthProvider';
import { Article } from '../../../../generated/graphqlModels';
import Loader from '../../../../components/Loader';
import { GET_ARTICLE } from './queries';

const timestamp = new Date().getTime();

interface ArticleProps {
  articleId: string;
  context: User;
  updateParentState: (newState: any) => void;
}

const ArticleComponent = forwardRef<HTMLIFrameElement, ArticleProps>(
  (props, iframeRef) => {
    const { articleId, context, updateParentState } = props;
    const {
      data: articleData,
      loading: isLoadingArticle,
      error: articleError,
    } = useQuery(GET_ARTICLE, { variables: { articleId } });

    const [article, setArticle] = useState<Article>();

    useEffect(() => {
      if (articleData && articleData.article) {
        setArticle(articleData.article);
      }
    }, [articleData]);

    useEffect(() => {
      updateParentState({ name: article?.name });
    }, [article]);

    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
      if (article) {
        switch (article.mediaType) {
          case 'pdf':
            setIsLoading(true);
            break;
          case 'cms':
            break;
          case 'file':
            break;
          case 'drive':
            break;
          case 'assessment':
            break;
          default:
            setIsLoading(true);
        }
      }
    }, [article]);

    const onIframeLoad = () => {
      setIsLoading(false);
    };

    if (article == null) {
      return null;
    }

    return (
      <Box
        sx={{
          '.sidebar-opened &': {
            width: '100%',
            left: 0,
          },
        }}
        transition="500ms"
        w="100%"
        p="10px"
        position="relative"
      >
        {article.mediaType === 'pdf' ? (
          <iframe
            title="pdf"
            ref={iframeRef}
            src={
              '/static/ui/pdfjs/web/viewer.html?file=' +
              article.pdfUrl +
              '&timestamp=' +
              timestamp
            }
            frameBorder="0"
            allowFullScreen
            width="100%"
            height="100vh"
            style={{ height: '100vh' }}
            onLoad={() => onIframeLoad()}
          />
        ) : article.mediaType === 'cms' ? (
          <JsonCmsContent
            ref={iframeRef}
            content={article as any}
            isChalkedUp={false}
            isChalkupsLoading={false}
            isTeacherGuideDisplayed={false}
            toggleComplete={() => {}}
            // @ts-ignore
            studyGroup={{}}
            goToNextResource={() => {}}
            popup={null}
            setPopup={() => {}}
            shouldGoNext={0}
            setShouldGoNext={() => {}}
            presentationEnabled={false}
            setPresentationEnabled={() => {}}
            showAllSections={false}
            hideNavigation={false}
            uncompletable={true}
          />
        ) : article.mediaType === 'file' ? (
          <div style={{ textAlign: 'left', paddingLeft: '10px' }}>
            <p>To access {article.name} click the download button.</p>
            <ul>
              <li>{article.fileUrl?.substr('/media/'.length)}</li>
            </ul>
          </div>
        ) : article.mediaType === 'drive' ? (
          <iframe
            ref={iframeRef}
            title="Drive"
            src={article.driveUrl || ''}
            width="100%"
            height="100vh"
            style={{ height: '100vh' }}
            frameBorder="0"
            onLoad={() => onIframeLoad()}
          >
            Loading...
          </iframe>
        ) : article.mediaType === 'assessment' ? null : (
          <iframe
            title="Media"
            ref={iframeRef}
            // @ts-ignore
            src={article[`${article.mediaType}Url`]}
            frameBorder="0"
            allowFullScreen
            onLoad={() => onIframeLoad()}
          />
        )}
        {isLoading && <Loader />}
      </Box>
    );
  },
);

export default ArticleComponent;
